
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.204","height":"22.5","viewBox":"0 0 17.204 22.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 16761","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 22321","d":"M16.892 15.442l-1.066-1.3a5.491 5.491 0 01-1.232-3.434V8.289a6.019 6.019 0 00-4.712-5.873V1.279a1.279 1.279 0 10-2.558 0v1.137A6 6 0 002.611 8.29v2.416a5.356 5.356 0 01-1.232 3.434l-1.066 1.3a1.4 1.4 0 001.066 2.274h14.424a1.4 1.4 0 001.089-2.272z"}}),_c('path',{attrs:{"data-name":"Path 22322","d":"M8.602 22.5a3.073 3.073 0 003.079-3.079H5.523A3.073 3.073 0 008.602 22.5z"}})])])
          )
        }
      }
    